module.exports = __webpack_public_path__ + "img/files.63b89956.svg";